import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_moma_11: FaireProductEntity = {
  token: "atc_updated_moma_11",
  type: "product",
  name: "Pixel Flower & Geometric Mugs",
  brandName: "MoMA Design Store",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/f870daf6e2d555e321ff766d6109dbebe8e2b6af1139b38d8801caac84c91f92.webp",
  priceDollars: 26,
  msrpDollars: 32,
  description: "Modern graphic mug designs.",
  tags: ["home", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
